@if (invite || preview) {
  <section class="ignosis-transfer">
    <header>
      <strong>Transferred call</strong>
      @if (invite?.reason) {
        <p>{{ invite.reason }}</p>
      }
      @if (invite?.dueId) {
        <a [routerLink]="['/timeline', invite.dueId]">Open case</a>
      } @else if (!invite) {
        <p>Preview. No live transfer.</p>
      } @else {
        <p>This transfer has no matching case.</p>
      }
    </header>
    @if (invite) {
      <iframe #frame [src]="frameUrl" title="Transferred call" allow="microphone; autoplay"></iframe>
    }
    <button type="button" (click)="invite ? (state === 'joined' ? leave() : decline()) : closePreview()">
      {{ state === 'joined' ? 'Leave call' : 'Decline' }}
    </button>
  </section>
}
@if (notice) {
  <p class="ignosis-transfer-notice">{{ notice }}</p>
}
